import {
  ActionSheet,
  Avatar,
  Button,
  InfiniteScroll,
  NavBar,
  Skeleton,
  Toast,
} from "antd-mobile";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.css";
import { MoreOutline } from "antd-mobile-icons";
import { useEffect, useState } from "react";
import request from "../../axios";

const Shop = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState(true);
  const [pageNo, setPageNo] = useState<number>(1);
  const [userList, setUserList] = useState<any>([]);
  const [nowInfo, setNowInfo] = useState<any>({});

  const actions: any[] = [
    {
      text: "编辑成员",
      key: "edit",
      onClick: () => {
        navigate(`/sales/edit?type=edit&info=${JSON.stringify(nowInfo)}`);
      },
    },
    {
      text: "删除成员",
      key: "delete",
      onClick:async () => {
        try {
         await request.post(`/user/delete/${nowInfo.id}`)
        } catch (error) {
        } finally {
          getDataList(1);
          setVisible(false);
          Toast.show("删除成功");
        }
      },
    },
  ];

  const getDataList = async (page: number = 1) => {
    try {
      const { data } = await request.get("/user/list", {
        pageNo: page,
        pageSize: 10,
      });
      if (data) {
        if (page === 1) {
          setUserList(data?.records || []);
        } else {
          setUserList((prev: any) => [...prev, ...(data?.records || [])]);
        }
        // 更新是否有更多数据
        setHasMore(
          data?.records?.length >= 10 && (data?.total || 0) > page * 10
        );
      }
    } catch (error) {}
  };

  // 加载更多数据
  const loadMore = async () => {
    await getDataList(pageNo);
    setPageNo((prev) => prev + 1);
  };

  useEffect(() => {
    getDataList();
  }, []);

  return (
    <div className="detail" style={{ background: "rgb(242,244,247)" }}>
      <NavBar
        onBack={() => {
          navigate(-1);
        }}
      >
        成员管理
      </NavBar>
      <div className={styles.content}>
        {userList?.map((item: any, ind: number) => {
          const type = item?.status ? "center_title" : "center_title1";
          return (
            <div className={styles.shop_item}>
              <div className={styles.top_title}>
                <div className={styles.title_left}>
                  <Avatar
                    src=""
                    style={{ "--size": "48px", borderRadius: "50%" }}
                  />
                  <span>{item?.name}</span>
                </div>
                <MoreOutline
                  fontSize={20}
                  onClick={() => {
                    setNowInfo(item);
                    setVisible(true);
                  }}
                />
              </div>
              <div className={styles.center}>
                <div className={styles[`${type}`]}>
                  ● {item?.status ? "启用中" : "停用中"}
                </div>
                <span>{item?.phone}</span>
              </div>
            </div>
          );
        })}
        <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
      </div>
      <div className={styles.bottom}>
        <Button
          className={styles.subbtn}
          onClick={() => navigate(`/sales/edit?type=add`)}
        >
          添加成员
        </Button>
      </div>
      {/* <Skeleton.Paragraph lineCount={5} animated /> */}
      <ActionSheet
        extra="请选择你要进行的操作"
        cancelText="取消"
        visible={visible}
        actions={actions}
        onClose={() => setVisible(false)}
      />
    </div>
  );
};

export default Shop;
